import { render, staticRenderFns } from "./ConfirmRemoveCollectionModal.vue?vue&type=template&id=6b06780e&scoped=true&"
import script from "./ConfirmRemoveCollectionModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmRemoveCollectionModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmRemoveCollectionModal.vue?vue&type=style&index=0&id=6b06780e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06780e",
  null
  
)

export default component.exports